<template>
  <div :class="$style.contentBox">
    <div v-if="step === 1">
      <!-- <van-form :show-error-message="false" @submit="nextStep" validate-trigger="onChange"> -->
      <van-form :show-error-message="false">
        <common-lable><span :class="$style.red">*</span>{{ $t('common.Pleaseselectenteringorleaving') }}</common-lable>
        <van-radio-group
          v-model="personalInfo.entryExitType"
          direction="horizontal"
          :class="$style.radioGroup">
          <van-radio name="0" shape="square" :class="$style.radio">{{ $t('common.Immigration') }}</van-radio>
          <van-radio name="1" shape="square" :class="$style.radio">{{ $t('common.Exit') }}</van-radio>
        </van-radio-group>
        <common-lable>
          <span :class="$style.red">*</span>
          {{ personalInfo.entryExitType === '0' ? $t('common.EntryFrom') : $t('common.ExitTo') }}</common-lable>
        <van-field
          :class="$style.input"
          v-model="personalInfo.entryExit"
          :placeholder="personalInfo.entryExitType === '0'
            ? $t('common.Pleaseenteryourplaceofentry') : $t('common.Pleaseenteryourexitdestination')"
          :rules="[{ required: true, message: personalInfo.entryExitType === '0'
            ? $t('common.Pleaseenteryourplaceofentry') : $t('common.Pleaseenteryourexitdestination') }]"/>
        <common-title>{{ $t('common.PartIcontent') }}</common-title>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.Name') }}</common-lable>
        <van-field
          :class="$style.input"
          v-model="personalInfo.name"
          :placeholder="$t('common.Pleaseenteryourname')"
          :rules="[{ required: true, message: $t('common.Pleaseenteryourname') }]"/>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.Gender') }}</common-lable>
        <van-radio-group
          v-model="personalInfo.gender"
          direction="horizontal"
          :class="$style.radioGroup">
          <van-radio name="0" shape="square" :class="$style.radio">{{ $t('common.M') }}</van-radio>
          <van-radio name="1" shape="square" :class="$style.radio">{{ $t('common.F') }}</van-radio>
        </van-radio-group>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.Nationality') }}</common-lable>
        <van-field
          :class="$style.input"
          readonly
          clickable
          name="picker"
          :value="personalInfo.nationality"
          :placeholder="$t('common.Pleaseenteryournationality')"
          @click="showcountyPicker = true"
          :rules="[{ required: true, message: $t('common.Pleaseenteryournationality') }]"/>
        <van-popup v-model="showcountyPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="countyNameList"
            @confirm="onCountryConfirm"
            ref="currencyNamePicker"
            @cancel="showcountyPicker = false"/>
        </van-popup>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.PlaceofBirth') }}</common-lable>
        <van-field
          :class="$style.input"
          v-model="personalInfo.birthplace"
          :placeholder="$t('common.Pleaseenteryourplaceofbirth')"
          :rules="[{ required: true, message: $t('common.Pleaseenteryourplaceofbirth') }]"/>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.DateofBrith') }}</common-lable>
        <van-field
          :class="$style.input"
          readonly
          clickable
          name="datetimePicker"
          :value="personalInfo.birthTime|datePick"
          :placeholder="$t('common.Pleaseselectyourdateofbirth')"
          :rules="[{ required: true, message: $t('common.Pleaseselectyourdateofbirth') }]"
          @click="showDatePicker = true"/>
        <van-popup v-model="showDatePicker" position="bottom">
          <van-datetime-picker
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            v-model="brithDay"
            @confirm="onDateConfirm"
            @cancel="showDatePicker = false"/>
        </van-popup>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.TravelDocumentType') }}</common-lable>
        <van-field
          :class="$style.input"
          readonly
          clickable
          name="picker"
          :value="personalInfo.documentType"
          :placeholder="$t('common.Pleaseselectyourdocumentcategory')"
          @click="showPicker = true"
          :rules="[{ required: true, message: $t('common.Pleaseselectyourdocumentcategory') }]"/>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="documentNameList"
            @confirm="onConfirm"
            @cancel="showPicker = false"/>
        </van-popup>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.TravelDocumentNumber') }}</common-lable>
        <van-field
          :class="$style.input"
          v-model="personalInfo.documentNum"
          :placeholder="$t('common.PleaseenteryourIDnumber')"
          :rules="[{ required: true, message: $t('common.PleaseenteryourIDnumber') }]"/>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.PlaceofIssue') }}</common-lable>
        <van-field
          :class="$style.input"
          v-model="personalInfo.issue"
          :placeholder="$t('common.Pleaseenteryourplaceofissue')"
          :rules="[{ required: true, message: $t('common.Pleaseenteryourplaceofissue') }]"/>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.Permanentresidenceaddress') }}</common-lable>
        <van-field
          :class="$style.input"
          v-model="personalInfo.address"
          maxlength="200"
          :placeholder="$t('common.Pleaseenteryourpermanentresidenceaddress')"
          :rules="[{ required: true, message: $t('common.Pleaseenteryourpermanentresidenceaddress') }]"/>
        <common-lable><span :class="$style.red">*</span>{{ $t('common.Contactnumber') }}</common-lable>
        <div :class="$style.phoneBox">
          <van-field
            :class="$style.phoneInputTitle"
            left-icon="plus"
            :placeholder="$t('common.Code')"
            maxlength="4"
            v-model="phoneTitle"
            :rules="[{ required: true, message: $t('common.Code') }]"/>
          <div :class="$style.phoneInputCenter">-</div>
          <van-field
            :class="$style.phoneInput"
            v-model="personalInfo.phone"
            :placeholder="$t('common.Pleaseenteryourcontactnumber')"
            :rules="[{ required: true, message: $t('common.Pleaseenteryourcontactnumber')}]"/>
        </div>
        <div :class="$style.buttonBox">
          <!-- <van-button :class="$style.button-primary" native-type="submit" @click="click=true"><span>下一步</span></van-button> -->
          <van-button :class="$style.buttonPrimary" @click="nextStep" native-type="button">
            <span>{{ $t('common.Nextstep') }}</span>
          </van-button>
        </div>
      </van-form>
    </div>
    <div v-if="step === 2">
      <common-title>{{ $t('common.PartIIcontent') }}</common-title>
      <!-- @submit="handleSave" -->
      <van-form :show-error-message="false" validate-trigger="onChange">
        <div v-for="(item,index) in cashInfo" :key="index">
          <div style="position: relative;">
            <item-title :data="index"/>
            <a @click="handleDel(index)" style="position: absolute; right: 4px; top: 0; color: #43a6df;" v-if="index!==0">
              {{ $t('common.Delete') }}
            </a>
          </div>
          <van-radio-group
            v-model="item.cashType"
            direction="horizontal"
            :rules="[{ required: true, message: $t('common.Pleaseselectthecurrencytype')}]"
            :class="$style.radioGroups">
            <van-radio
              v-for="(i,j) in cashTypes"
              :name="i.name"
              :key="j"
              shape="square"
              :class="$style.radio">{{ i.lable }}</van-radio>
            <van-field
              :class="$style.radioInput"
              v-if="item.cashType === '6'"
              :placeholder="$t('common.Pleaseenter')"
              :disabled="item.cashType === '6'? false : true"
              v-model="item.cashTypeOth"/>
          </van-radio-group>
          <!--<common-lable>貨幣名稱</common-lable>
            <van-field
              :class="$style.input"
              v-model="item.currencyType"
              placeholder="請輸入貨幣名稱"
              :rules="[{ required: true, message: '請輸入貨幣名稱' }]"/>-->
          <common-lable>{{ $t('common.Currencyname') }}</common-lable>
          <van-field
            :class="$style.input"
            readonly
            clickable
            name="picker"
            v-model="item.currencyType"
            :placeholder="$t('common.Pleaseselectyourcurrencyname')"

            @click="setCurrencyIndex(index)"
            :rules="[{ required: true, message: $t('common.Pleaseselectyourcurrencyname') }]"/>
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="currencyNameList"
              @confirm="(data,i)=>{onCurrencyConfirm(data)}"
              ref="currencyNamePicker"
              @cancel="showPicker = false"/>
          </van-popup>
          <common-lable>{{ $t('common.Amounttonearestwholenumber') }}</common-lable>
          <!-- <van-field
            :class="$style.input"
            v-model="item.moneyString"
            @blur="formatMoneyBlur(index)"
            @focus="formatMoneyFocus(index)"
            placeholder="請輸入數額(最接近整數)"
            :rules="[{ required: true, message: '請輸入數額(最接近整數)' }]"/> -->
          <van-field
            :class="$style.input"
            v-model="item.moneyString"
            @input="(value)=>handleMoney(value,index)"
            :placeholder="$t('common.Pleaseentertheamount')"
            :rules="[{ required: true, message: $t('common.Pleaseentertheamount') }]"/>
          <common-lable>{{ $t('common.Doesthedeclarantownthisitem') }} </common-lable>
          <div :class="$style.box1">
            <van-radio-group
              v-model="item.myself"
              direction="horizontal"
              :class="$style.radioGroup">
              <van-radio name="1" shape="square" :class="$style.radio">{{ $t('common.Yes') }}</van-radio>
              <van-radio name="0" shape="square" :class="$style.radio">{{ $t('common.No') }}</van-radio>
              <div :class="$style.info">({{ $t('common.theownershouldbeidentifiedontheappropriatefieldofPartIII') }})</div>

            </van-radio-group>
          </div>
          <!-- <div :class="$style.info">({{ $t('common.theownershouldbeidentifiedontheappropriatefieldofPartIII') }})</div> -->
          <div v-if="item.myself ==='0'" style="position: relative;" :class="$style.l">
            <common-title>{{ $t('common.PartIIIcontent') }}</common-title>
            <item-title :data="index"/>
            <van-button
              v-if="index > 0 && item.myself === '0' && cashInfo[0].myself === '0'"
              @click="synchronization(item,index)"
              :class="$style.btns"
              style="position: absolute; right: 4px; top: 0; color: #43a6df;"
              type="primary">{{ item.btnMsg }}</van-button>
            <van-radio-group
              v-model="item.dataType"
              :direction="$store.getters.language === 'cn'?'horizontal':'vertical'"
              @change="(e)=>handleRadio(e,index)">
              <van-radio name="0" shape="square">
                <common-lable>{{ $t('common.LegalPersonCorporatename') }}</common-lable>
              </van-radio>
              <!--<van-field
                  :class="$style.input"
                  v-model="item.name"
                  placeholder="請輸入名稱(法人)"
                  :rules="[{ required: true, message: '請輸入名稱(法人)' }]"/>-->
              <van-radio
                name="1"
                shape="square"
                :style="$store.getters.language === 'cn'?'margin-left: 20px':'margin-top: 5px'">
                <common-lable>{{ $t('common.IndividualName') }}</common-lable>
              </van-radio>
            </van-radio-group>
            <van-field
              :class="$style.input"
              v-model="item.name"
              :placeholder="$t('common.Pleaseenteryourname')"
              :rules="[{ required: true, message: $t('common.Pleaseenteryourname') }]"/>
            <van-radio-group
              v-if="item.dataType ==='1'"
              v-model="item.gender"
              direction="horizontal"
              :class="$style.radioGroup">
              <van-radio name="0" shape="square" :class="$style.radio">{{ $t('common.M') }}</van-radio>
              <van-radio name="1" shape="square" :class="$style.radio">{{ $t('common.F') }}</van-radio>
            </van-radio-group>
            <common-lable>{{ $t('common.Address') }}</common-lable>
            <van-field
              :class="$style.input"
              maxlength="500"
              v-model="item.address"
              :placeholder="$t('common.Pleaseenterthepermanentresidenceaddressofthelegalentitynaturalperson')"
              :rules="[{ required: true, message: $t('common.Pleaseenterthepermanentresidenceaddressofthelegalentitynaturalperson') }]"/>
          </div>
        </div>
        <van-button :class="$style.buttonAdd" @click="handleAddClick" v-if="cashInfo.length!==30">
          <span>+{{ $t('common.Addthenextitem') }}</span>
        </van-button>
        <div :class="$style.checkBox">
          <span :class="$style.red">*</span><van-checkbox :class="$style.checkbox" shape="square" v-model="allow"/>
          <!-- <span :class="$style.checkBoxSpan">本人聲明已閱讀<a @click="showDialog">《申報須知》</a>，並聲明所填寫的資料屬實和完整。</span> -->
          <span :class="$style.checkBoxSpan"><a @click="showDialog">{{ $t('common.Ideclare') }}</a></span>
        </div>
        <div :class="$style.checkBox">
          <van-checkbox
            style="margin-left: 9px;"
            :class="$style.checkbox"
            shape="square"
            v-model="allowCookies"/>
          <span :class="$style.checkBoxSpan">{{ $t('common.Keepthefilinginformation') }}</span>
        </div>
        <div :class="$style.verification">
          <van-field
            :class="$style.verificationInput"
            v-model="personalInfo.key"
            :placeholder="$t('common.Pleasepresstheicontoentertheverificationcode')"
            :rules="[{ required: true, message: $t('common.Pleasepresstheicontoentertheverificationcode') }]"/>
          <img :class="$style.verificationImg" :src="Verification" @click="getVerification"/>
        </div>
        <div :class="$style.buttonBox">
          <van-button
            style="margin-bottom: 20px;"
            :class="$style.buttonInfo"
            @click="beforeStep"><span>{{ $t('common.Stepup') }}</span></van-button>
          <!-- native-type="submit" -->
          <van-button :class="$style.buttonPrimary" @click="handleSave"><span>{{ $t('common.Submit') }}</span></van-button>
        </div>
      </van-form>
    </div>
    <van-popup v-model="doalogShow">
      <common-dialog @close="handelCloseone" :title="$t('common.Whatyouneedtoknowtodeclare')">
        <c-info type="1"/>
      </common-dialog>
    </van-popup>
    <van-popup v-model="successShow">
      <common-dialog @close="handelClose" :title="$t('common.Thesubmissionwassuccessful')">
        <div :class="$style.qrcode">
          <div :class="$style.imgBox">
            <img :src="QRcode"/>
          </div>
          <van-button @click="handleSaveClick" type="info"><span>{{ $t('common.Save') }}</span></van-button>
          <span :class="$style.Span">
            {{ $t('common.pleasekeepthisQRcode') }}
          </span>
        </div>
      </common-dialog>
    </van-popup>

  </div>
</template>

<script>
  import { Button, Form, Field, RadioGroup, Radio, DatetimePicker, Popup, Picker, Checkbox, Notify} from "vant";
  import Info from "../../components/info";
  import { commonLable, commonTitle, itemTitle, commonDialog } from "./components";
  import filters from "../../filters";
  import CryptoJS from "crypto-js";
  import downloadImg from "../../utils/downloadImg";
  import api from "../../api";
  export default {
    name: "Mobile",
    components: {
      "van-button": Button,
      "van-form": Form,
      "van-field": Field,
      "van-radio": Radio,
      "van-checkbox": Checkbox,
      "van-radio-group": RadioGroup,
      "van-datetime-picker": DatetimePicker,
      "van-picker": Picker,
      "van-popup": Popup,
      "c-info": Info,

      commonLable,
      commonTitle,
      itemTitle,
      commonDialog
    },
    data () {
      return {
        // daiyu
        currencyCode: "",
        currencyIndex: "",
        // daiyu
        title: "mobile",
        indexs: null,
        QRcode: "",
        showcountyPicker: false,
        click: false,
        phoneTitle: null,
        step: 1,
        doalogShow: false,
        successShow: false,
        brithDay: new Date(1980, 0, 1),
        minDate: new Date(1920, 0, 1),
        maxDate: new Date(),
        cashTypes: [
          {
            lable: this.$t("common.Currency"),
            name: "0"
          },
          {
            lable: this.$t("common.Travellerscheque"),
            name: "1"
          },
          {
            lable: this.$t("common.Cheque"),
            name: "2"
          },
          {
            lable: this.$t("common.Billofexchange"),
            name: "3"
          },
          {
            lable: this.$t("common.MoneyOrder"),
            name: "4"
          },
          {
            lable: this.$t("common.PromissoryNote"),
            name: "5"
          },
          {
            lable: this.$t("common.Others"),
            name: "6"
          }
        ],
        personalInfo: {
          name: "",
          gender: "",
          nationality: "",
          birthplace: "",
          birthTime: "",
          address: "",
          phone: "",
          documentType: "",
          documentNum: "",
          issue: "",
          entryExitType: "",
          entryExit: "",
          key: ""
        },
        cashInfo: [
          {
            cashType: "",
            currencyType: "",
            money: "",
            moneyString: "",
            myself: "",
            dataType: "",
            name: "",
            gender: "",
            address: "",
            cashTypeOth: "",
            btnMsg: `${this.$t("common.synchronizationText")}`,
            i: 0
          }
        ],
        showPicker: false,
        showDatePicker: false,
        allowCookies: false,
        allow: false,
        VerificationID: "",
        Verification: "",
        seafKey: null,
        currencyTypeList: [],
        currencyNameList: [],
        countyList: [],
        countyNameList: [],
        documentList: [],
        documentNameList: []
      };
    },
    computed: {
      languageTypeData () {
        return this.$store.state.language;
      }
    },
    // 监听执行
    watch: {
      languageTypeData () {
        this.getCurrency();
        this.getCountry();
        this.getDictionary();
        this.cashTypes = [
          {
            lable: this.$t("common.Currency"),
            name: "0"
          },
          {
            lable: this.$t("common.Travellerscheque"),
            name: "1"
          },
          {
            lable: this.$t("common.Cheque"),
            name: "2"
          },
          {
            lable: this.$t("common.Billofexchange"),
            name: "3"
          },
          {
            lable: this.$t("common.MoneyOrder"),
            name: "4"
          },
          {
            lable: this.$t("common.PromissoryNote"),
            name: "5"
          },
          {
            lable: this.$t("common.Others"),
            name: "6"
          }
        ];
        // console.log(this.cashInfo);
        this.cashInfo.forEach(item => {
          if (item.i === 0) {
            item.btnMsg = `${this.$t("common.synchronizationText")}`;
          } else {
            item.btnMsg = `${this.$t("common.cancelSynchronizationText")}`;
          }
        });
        // console.log(this.cashTypes);
      }
    },
    methods: {
      synchronization (item, idx) {
        if (this.cashInfo[idx].btnMsg === `${this.$t("common.synchronizationText")}`) {
          this.cashInfo[idx].btnMsg = `${this.$t("common.cancelSynchronizationText")}`;
          this.cashInfo[idx].i = 1;
          this.cashInfo[idx].address = this.cashInfo[0].address;
          this.cashInfo[idx].dataType = this.cashInfo[0].dataType;
          this.cashInfo[idx].name = this.cashInfo[0].name;
          this.cashInfo[idx].gender = this.cashInfo[0].gender;
        } else {
          this.cashInfo[idx].btnMsg = `${this.$t("common.synchronizationText")}`;
          this.cashInfo[idx].i = 0;
          this.cashInfo[idx].address = "";
          this.cashInfo[idx].dataType = "";
          this.cashInfo[idx].name = "";
          this.cashInfo[idx].gender = "";
        }
        // if (this.cashInfo[idx].btnMsg === "同第一項") {
        //   this.cashInfo[idx].btnMsg = "取消同第一項";
        //   this.cashInfo[idx].address = this.cashInfo[0].address;
        //   this.cashInfo[idx].dataType = this.cashInfo[0].dataType;
        //   this.cashInfo[idx].name = this.cashInfo[0].name;
        //   this.cashInfo[idx].gender = this.cashInfo[0].gender;
        // } else {
        //   this.cashInfo[idx].btnMsg = "同第一項";
        //   this.cashInfo[idx].address = "";
        //   this.cashInfo[idx].dataType = "";
        //   this.cashInfo[idx].name = "";
        //   this.cashInfo[idx].gender = "";
        // }
      },
      nextStep () {
        // this.step = 2;
        const data = this.personalInfo;
        // 入籍和出境
        if (data.entryExitType === "") {
          Notify({ type: "warning", message: this.$t("common.Pleaseselectenteringorleavings") });
          return;
        }
        // 入籍地址
        if (data.entryExit === "") {
          Notify({ type: "warning", message: this.$t("common.rujin") });
          return;
        }
        // 姓名
        if (data.name === "") {
          Notify({ type: "warning", message: this.$t("common.names") });
          return;
        }
        // 性别
        if (data.gender === "") {
          Notify({ type: "warning", message: this.$t("common.Genders") });
          return;
        }
        // 国籍
        if (data.nationality === "") {
          Notify({ type: "warning", message: this.$t("common.Nationalitys") });
          return;
        }
        // 出生地
        if (data.birthplace === "") {
          Notify({ type: "warning", message: this.$t("common.birthplaces") });
          return;
        }
        // 出生日期
        if (data.birthTime === "") {
          Notify({ type: "warning", message: this.$t("common.birthTimes") });
          return;
        }
        // 證件類別
        if (data.documentType === "") {
          Notify({ type: "warning", message: this.$t("common.documentTypes") });
          return;
        }
        // 證件號碼
        if (data.documentNum === "") {
          Notify({ type: "warning", message: this.$t("common.documentNums") });
          return;
        }
        // 簽發地
        if (data.issue === "") {
          Notify({ type: "warning", message: this.$t("common.issues") });
          return;
        }
        // 永久居住地址
        if (data.address === "") {
          Notify({ type: "warning", message: this.$t("common.addresss") });
          return;
        }
        // 联系电话
        if (data.phone === "" || this.phoneTitle === "") {
          Notify({ type: "warning", message: this.$t("common.phones") });
          return;
        }
        if (
          data.address && data.birthTime &&
          data.birthplace && data.documentNum &&
          data.documentType && data.entryExit &&
          data.entryExitType && data.gender &&
          data.issue && data.name &&
          data.nationality && data.phone
        ) {
          this.step = 2;
        } else {
          // Notify({ type: "warning", message: this.$t("common.tishi") });
        }
        //
        window.scrollTo(0, 0);
        // 為了防止返回上一步自動校驗
        // if (this.click) {
        //   this.step = 2;
        //   this.click = false;
        // }
      },
      beforeStep () {
        this.step = 1;
        this.phoneTitle === "" ? this.phoneTitle = null : null;
        window.scrollTo(0, 0);
      },
      handleTrim (data) {
        // eslint-disable-next-line no-return-assign
        return data = data.replace(/^\s+|\s+$/g, "");
      },
      handleSave () {



        // const list = JSON.parse(JSON.stringify(this.cashInfo));
        // const data = { ...this.personalInfo, list: [...list]};
        // data.list = data.list.map((item, idx) => {
        //   item.sequence = idx;
        //   return item;
        // });
        // console.log(data);
        // return;
        // console.log(this.allow);

        if (this.allow) {
          // 加密传输
          const encryptor = new this.$jsEncrypt();
          encryptor.setKey(this.seafKey);
          const list = JSON.parse(JSON.stringify(this.cashInfo));
          // eslint-disable-next-line array-callback-return
          // list.map(item => {
          //   item.currencyType = this.currencyTypeList[this.currencyTypeList.findIndex(i => i.name === item.currencyType)].code;
          // });
          const data = { ...this.personalInfo, list: [...list]};
          data.list = data.list.map((item, idx) => {
            item.sequence = idx + 1;
            return item;
          });
          data.nationality = this.handleTrim(data.nationality);
          data.birthplace = this.handleTrim(data.birthplace);
          data.name = this.handleTrim(data.name);
          data.address = this.handleTrim(data.address);
          data.documentNum = this.handleTrim(data.documentNum);
          data.issue = this.handleTrim(data.issue);
          data.entryExit = this.handleTrim(data.entryExit);
          // console.log(this.currencyTypeList);
          // eslint-disable-next-line array-callback-return
          data.list.map(item => {
            if (this.currencyTypeList[this.currencyTypeList.findIndex(i => i.name === item.currencyType)] &&
              this.currencyTypeList[this.currencyTypeList.findIndex(i => i.name === item.currencyType)].code) {
              item.currencyType = this.currencyTypeList[this.currencyTypeList.findIndex(i => i.name === item.currencyType)].code;
            } else {
              item.currencyType = "";
            }

          });
          // eslint-disable-next-line array-callback-return
          // data.list.map(item => {
          //   item.name = this.handleTrim(item.name);
          //   item.address = this.handleTrim(item.address);
          // });
          data.list = data.list.filter(item => {
            return item.cashType !== "" || item.money !== "" ||
              item.currencyType !== "" || item.moneyString !== "" ||
              item.myself !== "";
          });

          // 校验 money 字段是否包含汉字
          const chineseRegex = /[\u4e00-\u9fa5]/;
          for (let i = 0; i < data.list.length; i++) {
            /* eslint-disable max-depth */
            if (data.list[i].money && chineseRegex.test(data.list[i].money)) {
              Notify({ type: "warning", message: this.$t("common.Pleaseentertheamount") });
              return;
            }

            // 新增：校验 money 是否为 0 或正整数
            const moneyVal = data.list[i].money;
            // 注意：如果 money 可能为 undefined/null/空字符串，根据业务决定是否允许
            if (moneyVal !== undefined && moneyVal !== null && moneyVal !== "") {
              // 转为数字（如果是字符串数字）
              const num = Number(moneyVal);
              // 判断是否为整数且 >= 0，并且不是 NaN/无穷
              if (!Number.isInteger(num) || num < 0) {
                Notify({ type: "warning", message: this.$t("common.Pleaseentertheamount") });
                return;
              }
            } else {
              // 如果 money 为空且不允许为空，可在这里处理；如果允许为空则跳过
            }
          }

          data.key = `${this.VerificationID}${this.personalInfo.key}`;
          // if (this.currencyTypeList[this.currencyTypeList.findIndex(i => i.name === item.currencyType)]) {

          // countyList国籍
          data.nationality = this.countyList[this.countyList.findIndex(i => i.name === data.nationality)].code;
          data.documentType = (this.documentList[this.documentList.findIndex(i => i.name === data.documentType)] || {}).code;
          data.phone = `${this.phoneTitle}-${this.personalInfo.phone}`;
          // data.documentType = this.documentList.indexOf(this.personalInfo.documentType);
          data.birthTime = filters.datePick(this.personalInfo.birthTime);
          // const params = encryptor.encryptLong(JSON.stringify(data));
          // console.log("未加密数据", data);
          // const params = encryptor.encryptLong2(JSON.stringify(data));
          // console.log(12, params);
          const languageType = this.$store.state.language === "cn" ? 0 : this.$store.state.language === "us" ? 1 : 2;
          data.language = languageType;
          delete data.id;
          console.log("未加密数据", data);
          // return;
          this.$emit("loading", true);
          data.remove = 0;
          const data1 = this.encrypt(JSON.stringify(data));
          api.insertCashInternet(data1).then(res => {
            this.QRcode = res[0].qrCode;
            this.successShow = true;
            Notify({ type: "success", message: this.$t("common.Thesavewassuccessful") });
            this.getVerification();
            if (this.allowCookies) {
              // const obj = {...this.personalInfo};
              const obj = res[0];

              // obj.phone = `${this.phoneTitle}-${obj.phone}`;

              // obj.entryExit = "";
              // obj.entryExitType = "";
              // obj.nationality = this.countyList[this.countyList.findIndex(
              //   i => i.name === obj.nationality
              // )].code;
              // obj.documentType = this.documentList[this.documentList.findIndex(
              //   i => i.name === obj.documentType
              // )].code;
              obj.QRcode = res[0].qrCode;
              // if (this.cashInfo.length === 3) {
              //   obj.list = this.cashInfo;
              // }
              // if (this.cashInfo.length === 2) {
              //   this.handleAddClick(1);
              //   obj.list = this.cashInfo;
              // }
              // if (this.cashInfo.length === 1) {
              //   this.handleAddClick(1);
              //   this.handleAddClick(1);
              //   obj.list = this.cashInfo;
              // }
              // for (let i = 0; i < obj.list.length; i++) {
              //   obj.list[i].money = "";
              //   obj.list[i].moneyString = "";
              // }
              obj.nationality = this.handleTrim(obj.nationality);
              obj.birthplace = this.handleTrim(obj.birthplace);
              obj.name = this.handleTrim(obj.name);
              obj.address = this.handleTrim(obj.address);
              obj.documentNum = this.handleTrim(obj.documentNum);
              obj.issue = this.handleTrim(obj.issue);
              obj.entryExit = this.handleTrim(obj.entryExit);
              // eslint-disable-next-line array-callback-return
              // obj.list.map(item => {
              //   item.name = this.handleTrim(item.name);
              //   item.address = this.handleTrim(item.address);
              // });
              obj.time = new Date();
              // delete obj.id;
              if (this.indexs !== null) {
                // const pageData = JSON.parse(localStorage.getItem("pageData"));
                // pageData[this.indexs] = obj;
                // localStorage.setItem("pageData", JSON.stringify(pageData));
                // console.log("1231231231");
                const pageData = localStorage.getItem("pageData") ? JSON.parse(localStorage.getItem("pageData")) : [];
                pageData.push(obj);
                pageData.reverse();
                localStorage.setItem("pageData", JSON.stringify(pageData));

              } else {
                // console.log("-----");
                const pageData = localStorage.getItem("pageData") ? JSON.parse(localStorage.getItem("pageData")) : [];
                pageData.push(obj);
                pageData.reverse();
                localStorage.setItem("pageData", JSON.stringify(pageData));
              }
              this.$emit("loading", false);
            }
          }).catch(() => {
            this.$emit("loading", false);
            this.getVerification();
          });
        } else {
          this.$emit("loading", false);
          Notify({ type: "warning", message: this.$t("common.Pleasemakesuretoreadthedeclaration") });

        }
        this.getVerification();


      },
      // 加密
      encrypt (word) {
        const key = CryptoJS.enc.Utf8.parse("abcdefgabcdefg12");
        const srcs = CryptoJS.enc.Utf8.parse(word);
        const encrypted = CryptoJS.AES.encrypt(srcs, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
        return encrypted.ciphertext.toString();
      },
      onDateConfirm (time) {
        this.personalInfo.birthTime = time;
        this.brithDay = time;
        this.showDatePicker = false;
      },
      onConfirm (value) {
        this.personalInfo.documentType = value;
        this.showPicker = false;
      },
      onCountryConfirm (data) {
        this.personalInfo.nationality = data;
        this.showcountyPicker = false;
      },
      // 设置pk的index
      setCurrencyIndex (index) {
        this.showPicker = true;
        this.currencyIndex = index;
      },
      // 货币确定的时候
      onCurrencyConfirm (data) {
        this.cashInfo[this.currencyIndex].currencyType = data;
        this.cashInfo[this.currencyIndex].code = (this.currencyTypeList.find(item => item.name === data) || {}).code;
        this.showPicker = false;
      },
      handleAddClick (type) {
        if (this.cashInfo.length === 30) {
          return;
        }
        this.cashInfo.push({
          cashType: type ? "" : "0",
          currencyType: "",
          money: "",
          moneyString: "",
          myself: "1",
          dataType: "",
          name: "",
          gender: "",
          sequence: this.cashInfo.length + 1,
          address: "",
          cashTypeOth: "",
          btnMsg: `${this.$t("common.synchronizationText")}`,
          i: 0
        });
      },
      showDialog () {
        this.doalogShow = true;
      },
      handelClose () {
        this.successShow = false;
        if (this.$route.path !== "/eDCBNI/mobile/List") {
          this.$router.push({path: "/eDCBNI/mobile/List"});
        }
        window.scrollTo(0, 0);
      },
      handelCloseone () {
        this.doalogShow = false;
      },
      // 处理金额 千分位 小数点
      formatMoneyBlur (num) {
        const oldVal = this.cashInfo[num].moneyString;
        if (oldVal) {
          const newVal = parseInt(oldVal);
          this.cashInfo[num].money = newVal;
          const formatVal = newVal.toLocaleString(newVal);
          this.cashInfo[num].moneyString = formatVal + ".00";
        }
      },
      handleMoney (value, index) {
        this.cashInfo[index].moneyString = value.replace(/[^\d]/g, "");
        this.cashInfo[index].moneyString = filters.comdify(value);
        this.cashInfo[index].money = filters.delcommafy(value);
      },
      formatMoneyFocus (num) {
        this.cashInfo[num].moneyString = this.cashInfo[num].money;
      },
      handleSaveClick () {
        const name = `${this.personalInfo.name}${filters.Qrcodetime(new Date())}`;
        downloadImg(this.QRcode, name);
      },
      getVerification () {
        api.getVerification().then(res => {
          this.VerificationID = res.imgId;
          this.Verification = res.img;
        });
      },
      handleDel (index) {
        this.cashInfo.splice(index, 1);
      },
      getkey () {
        api.getKey().then(res => {
          this.seafKey = res;
        });
      },
      handleRadio (e, index) {
        e === "0" ? this.cashInfo[index].gender = "" : null;
      },
      handleOpen (type) {
        switch (type) {
        case "aboutMe" : {
          this.showAboutme = true;
          break;
        }
        case "callMe" : {
          this.showCallme = true;
          break;
        }
        case "other" : {
          this.showOther = true;
          break;
        }
        }
      },
      // 获取货币
      async getCurrency () {
        const data = this.$store.state.language === "cn" ? 0 : this.$store.state.language === "us" ? 1 : 2;
        await api.getCurrency({language: data}).then(res => {
          this.currencyTypeList = [];
          this.currencyNameList = [];
          this.currencyTypeList = res;
          this.currencyTypeList.forEach(item => {
            this.cashInfo.forEach(val => {
              if (item.code === val.code) {
                val.currencyType = item.name;
              }
            });
          });
          this.currencyTypeList.map(item => this.currencyNameList.push(item.name));
        });
      },
      // 获取国籍
      async getCountry () {
        let nationality = "";
        const obj = this.countyList[this.countyList.findIndex(i => i.name === this.personalInfo.nationality)];
        if (obj && obj.code) {
          nationality = obj.code;
        }
        const data = this.$store.state.language === "cn" ? 0 : this.$store.state.language === "us" ? 1 : 2;
        await api.getCountry({language: data}).then(res => {
          this.countyList = [];
          this.countyNameList = [];
          this.countyList = res;
          if (this.countyList[this.countyList.findIndex(i => i.code === nationality)]) {
            this.personalInfo.nationality = this.countyList[this.countyList.findIndex(i => i.code === nationality)].name;
          }
          this.countyList.map(item => this.countyNameList.push(item.name));
        });
      },
      //  獲取證件類型
      async getDictionary () {
        let documentType = "";
        const obj = this.documentList[this.documentList.findIndex(i => i.name === this.personalInfo.documentType)];
        if (obj && obj.code) {
          documentType = obj.code;
        }
        const data = this.$store.state.language === "cn" ? 0 : this.$store.state.language === "us" ? 1 : 2;
        await api.getDictionary({language: data}).then(res => {
          // console.log(res);
          this.documentList = [];
          this.documentNameList = [];
          // this.personalInfo.documentType = "";
          this.documentList = res;
          if (this.documentList[this.documentList.findIndex(i => i.code === documentType)]) {
            this.personalInfo.documentType =
              this.documentList[this.documentList.findIndex(i => i.code === documentType)].name;
          }
          this.documentList.map(item => this.documentNameList.push(item.name));
        });
      }
    },
    async mounted () {
      if (this.$route.query.index) {
        this.indexs = this.$route.query.index - 1;
        const data = JSON.parse(localStorage.getItem("pageData"))[this.indexs];
        delete data.QRcode;
        data.birthTime = new Date(data.birthTime);
        // data.documentType = this.documentList[data.documentType];
        this.phoneTitle = data.phone.split("-")[0];
        data.phone = data.phone.split("-")[1];
        data.key = "";
        // const list = data.list.filter(item => {
        //   return item.currencyType !== "";
        // });
        // this.cashInfo = list;
        await this.getCountry().then(() => {
          if (this.countyList[this.countyList.findIndex(i => i.code === data.nationality)]) {
            data.nationality = this.countyList[this.countyList.findIndex(i => i.code === data.nationality)].name;
            // this.nationalityCode = this.countyList[this.countyList.findIndex(i => i.code === data.nationality)].code;
          }
        });
        await this.getDictionary().then(() => {
          if (this.documentList[this.documentList.findIndex(i => i.code === data.documentType)]) {
            data.documentType = this.documentList[this.documentList.findIndex(i => i.code === data.documentType)].name;
            this.personalInfo.documentType = data.documentType;
          }
        });
        // this.getCurrency().then(() => {
        //   // eslint-disable-next-line array-callback-return
        //   this.cashInfo.map(item => {
        //     item.currencyType = this.currencyTypeList[this.currencyTypeList.findIndex(i => i.code === item.currencyType)].name;
        //   });
        // });
        // delete data.list;
        data.entryExitType = String(data.entryExitType);
        data.gender = String(data.gender);
        // console.log(1);
        this.personalInfo = data;
        // console.log(this.personalInfo);
        // console.log(this.personalInfo);
      }
      window.scrollTo(0, 0);
      this.getVerification();
      this.getkey();
      this.getCurrency();
      this.getCountry();
      this.getDictionary();
    }
  };
</script>

<style lang="scss" module src="./style.scss">
</style>
<style scoped>
/deep/ .van-overlay {
  background-color: rgba(0,0,0,0.4) !important;
}
</style>
